import { useState } from 'react';
import { createCompany } from '@/services/company.service';

export function useCreateCompany(){
  const [loading,setLoading]=useState(false);

  const submit=async(payload)=>{
    setLoading(true);

    try {
      return await createCompany(payload);
    } catch (err) {
      const message =
        err?.response?.data?.errors?.email?.[0] ||
        err?.response?.data?.message ||
        err?.message ||
        'Request failed';

      const error = new Error(message);
      error.response = err.response;
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {submit,loading};
}
